import React, { useEffect, useRef, useState } from "react";
import FeaturedProducts from "../Components/Layout/FeaturedProducts";
import Products from "../Components/Layout/Product/Products";
import Modal from "../Components/Layout/Modal";
import { useAddProductContext } from "../Contexts/AddProductContext";
import AddProduct from "../Components/Layout/Product/AddProduct";
import DefaultLayout from "../Layouts/DefaultLayout";
import { useCartContext } from "../Contexts/CartContext";
import { useLoginContext } from "../Contexts/LoginContext";
import LoginSuccessful from "../Components/Layout/LoginSuccessful";
import StoreService from "../Services/StoreService";
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import { useStoreContext } from "../Contexts/StoreContext";
import { useLayoutContext } from "../Contexts/LayoutContext";
import { isArraysEqual } from "../Utils/Helpers";
import WelcomeStoreCounter from "../Components/Layout/WelcomeStoreCounter";
import { dataFakeForLoading, PRODUCT_TYPE_COMPOSITE } from "../Utils/Constants/Product";
import { useStoreHook } from "../Hooks/StoreHook";
import { ORDER_TYPE_STORE_COUNTER } from "../Utils/Constants/Service";
import { useCartHook } from "../Hooks/CartHook";
import Banners from "../Components/Layout/Banners";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { TbMoodConfuzed } from "react-icons/tb";
import { useTranslation } from "react-i18next";

const Home = () => {

    const { t } = useTranslation();
    const { showAddProduct, setShowAddProduct, product, category, redirectToProductSlug, setRedirectToProductSlug} = useAddProductContext();
    const { setCartTemp, showCartIsFinished, cartDisplay, showConfirmTable } = useCartContext();
    const { showLoginSuccessful, setShowLoginSuccessful, token } = useLoginContext();
    const { orderType, getOrderTypeIdByName, isStoreCounter } = useOrderTypeContext();
    const { currentStore, requiredTable, currentAddress } = useStoreContext();
    const { company, setProductsToSearch, welcomeScreenRead, 
        categories, setCategories, 
        loadingCategories, setLoadingCategories,
        allCategories, setAllCategories, setWelcomeScreenRead, isMobile, enableLoadProducts, setEnableLoadProducts } = useLayoutContext();
    const { getCashier, storeIsOpen, loadTables, findProductBySlug, getLinkToHome } = useStoreHook();
    const { getOpenedCustomerCartDiffStored } = useCartHook();
    const [ categoriesWhithoutFeaturedProducts, setCategoriesWhithoutFeaturedProducts ] = useState<any>([]);

    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const isFirstRender = useRef(true);

    const initialDynamicMeta = {
        title: currentStore?.name || company?.name,
        ogTitle: currentStore?.name || company?.name,
        description: 'Comanda Digital - Papa Filas - Delivery - PDV',
        ogDescription: 'Comanda Digital - Papa Filas - Delivery - PDV',
        ogImage: '',
    }
    const [ dynamicMeta, setDynamicMeta ] = useState<any>(initialDynamicMeta);
    const { slug_product } = useParams();
    const navigate = useNavigate();

    const loadProducts = async (enableLoading:boolean=true) => {
        if (!company) return;
        if (!enableLoadProducts) {
            setEnableLoadProducts(true);
            return;
        }
        setLoadingCategories(enableLoading);
        try {
            const storeSevice = new StoreService(orderType);
            const payload = {
                store_id: currentStore.id,
                order_type: Number(getOrderTypeIdByName(orderType))
            }
            const products = await storeSevice.products(payload);

            if (products?.length > 0) {
                handleCategories(products);
            } else {
                setCategories([]);
                setAllCategories([]);
            }
        } catch (error) {
            setCategories([]);
            setAllCategories([]);
        } finally {
            storeIsOpen();
            setLoadingCategories(false);

            //* Verificando se a comanda do localStorage é diferente da aberta e substuindo
            if (orderType === ORDER_TYPE_STORE_COUNTER && token && cartDisplay) {
                getOpenedCustomerCartDiffStored().catch(() => {});
            }
        }
    }

    const handleCategories = (products: any) => {
        const featuredLayout = String(company?.config?.display_layout?.featured || 'SWIPER_IMAGE').toLowerCase().trim();
        const mappedLayout = featuredLayout === 'swiper_image' ? 'swiper_image' : (featuredLayout === 'grid' ? 'grid' : (featuredLayout === 'list' ? 'list' : 'swiper_image'));

        const productsWithLayout = products.map((cat: any) => {
            if (cat.id === null || cat.id === undefined) {
                return { ...cat, layout: mappedLayout };
            }
            return cat;
        });

        setAllCategories(productsWithLayout);

        if (slug_product) {
            findProductBySlug(productsWithLayout, slug_product);
        }

        if (isMobile) {
            setCategories(productsWithLayout);
        } else {
            const categoriesWithoutFeaturedProducts = productsWithLayout.filter((cat: any) => cat.id != null);
            if (categoriesWithoutFeaturedProducts && categoriesWithoutFeaturedProducts.length > 0) {
                setCategoriesWhithoutFeaturedProducts(categoriesWithoutFeaturedProducts);
                setCategories(categoriesWithoutFeaturedProducts);
            }
        }
    }

    useEffect(() => {
        document.title = currentStore.name || company.name;
        loadProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleShowFeaturedProducts = () => {
        if (allCategories?.length > 0 && !isArraysEqual(allCategories, dataFakeForLoading)) {
            if (isMobile) {
                setCategories(allCategories)
            } else if (categoriesWhithoutFeaturedProducts.length > 0) {
                setCategories(categoriesWhithoutFeaturedProducts);
            }
        }
    }

    useEffect(() => {
        handleShowFeaturedProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);

    useEffect(() => {
        if (allCategories?.length > 0 && !isArraysEqual(allCategories, dataFakeForLoading)) {
            if (currentAddress && redirectToProductSlug) {
                navigate(`${getLinkToHome()}/produto/${redirectToProductSlug}`);
                setRedirectToProductSlug('');
            } else if (slug_product && slug_product !== product?.slug) {
                findProductBySlug(allCategories, slug_product);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slug_product, allCategories, currentAddress, redirectToProductSlug, product?.slug]);

    useEffect(() => {
        if (orderType === ORDER_TYPE_STORE_COUNTER) {
            if (currentStore && !cartDisplay) {
                getCashier();
            }
            if ((requiredTable || showConfirmTable || product) && token) {
                loadTables();
            }
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartDisplay, product, orderType]);

    useEffect(() => {
        setDynamicMeta(showAddProduct && product ? {
            title: product.name,
            ogTitle: product.name,
            description: product.description || '',
            ogDescription: product.description || '',
            ogImage: product?.photos?.medium || ''
        } : initialDynamicMeta);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showAddProduct, product]);

    useEffect(() => {
        if (allCategories?.length > 0 && !isArraysEqual(allCategories, dataFakeForLoading)) {
            const allProducts: any[] = [];

            //* Produtos das categorias
            allCategories.forEach((category: any) => {
                category.products?.forEach((product: any) => {
                    if (!allProducts.some((prod) => prod.id === product.id)) {
                        allProducts.push(product);
                    }
                });
            });

            //* Produtos das subcategorias
            allCategories.forEach((category: any) => {
                category.children?.forEach((child: any) => {
                    child.products.forEach((product: any) => {
                        if (!allProducts.some((prod) => prod.id === product.id)) {
                            allProducts.push(product);
                        }
                    });
                });
            });

            setProductsToSearch(allProducts);

            const categoriesWithoutFeaturedProducts = allCategories.filter((cat: any) => cat.id != null);
            if (categoriesWithoutFeaturedProducts) {
                setCategoriesWhithoutFeaturedProducts(categoriesWithoutFeaturedProducts);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allCategories]);

    const { setProduct, setCategory } = useAddProductContext();

    const handleCloseAddProduct = () => {
        setProduct(null);
        setCategory(null);
        setShowAddProduct(false);
        setCartTemp([]);
        navigate(getLinkToHome());
    }

    useEffect(() => {
        if (currentStore && currentLang && !isFirstRender.current) {
            loadProducts(false);
        }
        isFirstRender.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLang]);

    // useEffect removido para evitar conflitos com a navegação e busca

    return (
        <>
            <Helmet>
                <title>{dynamicMeta.title}</title>
                <meta name="description" content={dynamicMeta.description} />
                {/* <meta name="keywords" content={} /> Backend */}
                <meta name="robots" content="index, follow" />
                <meta name="author" content={currentStore.name} />
                <link rel="canonical" href={window.location.href} />

                {/* Open Graph */}
                <meta property="og:title" content={dynamicMeta.ogTitle} />
                <meta property="og:description" content={dynamicMeta.ogDescription} />
                <meta property="og:image" content={dynamicMeta.ogImage} />
            </Helmet>

            <DefaultLayout categories={categories}>
                {currentStore && currentStore.has_banner && <Banners />}
                {currentStore && <FeaturedProducts />}
                {(currentStore && categories?.length > 0)
                    ?   <Products categories={categories} loading={loadingCategories} />
                    :   <div className="w-full h-full flex gap-1 items-center justify-center text-gray-500">
                            <TbMoodConfuzed />
                            <span>{t('products.no_products_found')}</span>
                        </div>
                }
            </DefaultLayout>

            {/* MODAL ADD PRODUCT */}
            {product && !showCartIsFinished && !showConfirmTable && (
                <Modal 
                    rounded={!isMobile} 
                    open={showAddProduct} 
                    className={`w-full m-0 h-dvh md:h-auto ${product.type === PRODUCT_TYPE_COMPOSITE ? 'md:max-w-3xl lg:max-w-4xl' : 'md:max-w-lg'}`}
                    onClose={handleCloseAddProduct}
                    >
                    <AddProduct key={product.id} product={product} category={category} onCancel={handleCloseAddProduct} />
                </Modal>
            )}

            <Modal open={showLoginSuccessful} closeable={false} className="max-w-sm m-4" onClose={() => setShowLoginSuccessful(false)}>
                <LoginSuccessful />
            </Modal>

            {isStoreCounter &&
                <Modal rounded={false} open={Boolean(!welcomeScreenRead && company && currentStore)} closeable={false} className="flex items-center justify-center min-h-dvh w-full rounded-none" onClose={() => setWelcomeScreenRead(true)}>
                    <WelcomeStoreCounter />
                </Modal>
            }
        </>
    );
};

export default Home;